<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('campaigns.message_share')">
        <template v-slot:toolbar>
          <router-link
              to="/add-message-share-campaign"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <b-button size="sm" @click="navigate"><i class="fa fa-plus mr-2"></i> Kampanya Ekle</b-button>
          </router-link>

        </template>
        <template v-slot:preview>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "MessageShareCampaigns",
  components: { DataTable, DashboardBox },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {
    return {
      form : {

      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'id', label: '#', sortable: true},
          {key: 'name', label: 'Kampanya Adı', sortable: true},
          {key: 'image', label: 'Resimli?', sortable: true},
          {key: 'confirm_required', label: 'Onay Gerekli?', sortable: false},
          {key: 'limit', label: 'Giriş Hakkı', sortable: true},
          {key: 'page', label: 'Sayfası', sortable: true},
          {key: 'total_message', label: 'Toplam Mesaj', sortable: true},
          {key: 'singular_participation', label: 'Tekil Katılım', sortable: true},
          {key: 'message_share_campaigns', label: 'İşlem', sortable: false},
        ],
      },
      table : {
        items : [
          {'id' : '53', 'name' : 'Yeni Yıl 2019', 'limit' : '1', 'page' : 'yeni-yil-kampanyasi', 'total_message' : '1725', 'singular_participation' : '1855'},
          {'id' : '52', 'name' : 'Zaman Makinesi', 'limit' : '1', 'page' : 'zaman-makinesi', 'total_message' : '2429', 'singular_participation' : '2429'},
          {'id' : '51', 'name' : 'Kış 2019', 'limit' : '1', 'page' : 'kis-2019', 'total_message' : '1491', 'singular_participation' : '1491'},
        ],
      },
    }
  },
  mounted() {

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2'), route: "alert" },
      { title: this.$t('campaigns.message_share') }
    ]);
  }
}
</script>

<style scoped>
</style>
